import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import QueuePlayNextIcon from "@material-ui/icons/QueuePlayNext";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import WorkOutlineOutlinedIcon from "@material-ui/icons/WorkOutlineOutlined";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import { ReactComponent as SummarizeIcon } from "common/assets/summarize-icon.svg";

export const SECTION_BUDGET_SETTINGS = {
  id: "budget settings",
  path: "budget-settings/",
  subtitle: "Budget Settings",
  title: "Budget Settings",
  withStepper: false,
  withDate: false,
  menuText: "Budget Settings",
  menuIcon: <TableChartOutlinedIcon />,
};

export const SECTION_OVERVIEW = {
  id: "overview",
  path: "overview/",
  subtitle: "Overview",
  title: "Dashboard",
  withStepper: false,
  withDate: true,
  menuText: "Overview",
  menuIcon: <TrackChangesIcon />,
};
export const SECTION_BUDGET = {
  id: "start",
  path: "budget/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  menuText: "Start",
  menuIcon: <QueuePlayNextIcon />,
};

export const SECTION_USERS = {
  id: "users",
  path: "users/",
  subtitle: "User Menu",
  title: "Users",
  withStepper: false,
  withDate: true,
  menuText: "Users",
  menuIcon: <PeopleAltOutlinedIcon />,
};

export const SECTION_WORKFORCE_SETTINGS = {
  id: "workforce settings",
  path: "workforce-settings/",
  subtitle: "Workforce Settings",
  title: "Workforce Settings",
  withStepper: false,
  withDate: false,
  menuText: "Workforce Settings",
  menuIcon: <WorkOutlineOutlinedIcon />,
};

export const SECTION_EMPLOYEE_MANAGEMENT = {
  id: "employee management",
  path: "employee-management/",
  subtitle: "Employee Management",
  title: "Employee Management",
  withStepper: false,
  withDate: false,
  menuText: "Employee Management",
  menuIcon: <PeopleOutlineIcon />,
};

export const SECTION_ANALYSIS = {
  id: "analysis",
  path: "analysis/",
  subtitle: "Analysis",
  title: "Analysis",
  withStepper: false,
  withDate: false,
  menuText: "Analysis",
  menuIcon: <SummarizeIcon />,
};
